// extracted by mini-css-extract-plugin
export default {"wrapper":"Directory_wrapper__C0-Eb","table":"Directory_table__Wa-sw","headings":"Directory_headings__NAzBA","heading":"Directory_heading__XZE7X"};